import { customerConstants } from "../constants";
import { customerService } from "../services";
import { alertActions } from "./alertActions";

export const customerActions = {
  getCustomers,
  getCustomersPaginated,
  getCustomer,
  getExcelCustomers,
  addCustomerformalInfo,
  uploadExcelCustomer,
  customerToSupplier,
  addCustomer,
  editCustomer,
  getRelationCustomer,
  addCustomerNote,
  getCustomerNotes,
  getCustomerRelationToUser,
};

function getCustomersPaginated(filter = {}) {
  return (dispatch) => {
    dispatch(request());

    customerService.getCustomersPaginated(filter).then(
      (res) => {
        if (res === undefined) {
          dispatch(alertActions.error("ارتباط با سرور برقرار نیست"));
        } else if (res.success) {
          dispatch(success(res.data));
        } else if (res.success === false) {
          dispatch(failure(res.message));
          dispatch(alertActions.error(res.message));
        }

        setTimeout(() => dispatch(alertActions.clear()), 1500);
      },
      (error) => {
        dispatch(failure(error.toString()));
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    return { type: customerConstants.GET_CUSTOMERS_REQUEST };
  }
  function success(data) {
    return { type: customerConstants.GET_CUSTOMERS_SUCCESS, data };
  }
  function failure(error) {
    return { type: customerConstants.GET_CUSTOMERS_FAILURE, error };
  }
}

function getCustomers(filter) {
  return (dispatch) => {
    dispatch(request());

    customerService.getCustomers(filter).then(
      (res) => {
        console.log("got the customers");

        if (res === undefined)
          dispatch(alertActions.error("ارتباط با سرور برقرار نیست"));
        else if (res.success) {
          console.log("user into customerAction");
          dispatch(success(res.data));
        }

        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 1500);
      },
      (error) => {
        dispatch(failure(error.toString()));
        console.log("occure error");
        console.log(error.toString());
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    console.log("into request");
    return { type: customerConstants.GET_CUSTOMERS_REQUEST };
  }
  function success(customers) {
    console.log("into success");
    return { type: customerConstants.GET_CUSTOMERS_SUCCESS, customers };
  }
  function failure(error) {
    return { type: customerConstants.GET_CUSTOMERS_FAILURE, error };
  }
}

function getCustomer(mobile) {
  return (dispatch) => {
    dispatch(request(mobile));
    customerService.getCustomer(mobile).then(
      (res) => {
        console.log(res);
        if (res === undefined) {
          dispatch(alertActions.error("ارتباط با سرور برقرار نیست"));
          dispatch(failure("ارتباط با سرور برقرار نیست"));
        } else if (res.success) {
          console.log("user into customerAction");
          dispatch(success(res.data));
        } else if (res.success === false) {
          dispatch(alertActions.error(res.message));
          dispatch(failure(res.message));
        }

        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 1500);
      },
      (error) => {
        dispatch(failure(error.toString()));
        console.log("occure error");
        console.log(error.toString());
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    console.log("into request");
    return { type: customerConstants.GET_CUSTOMER_REQUEST };
  }
  function success(customer) {
    console.log("into success");
    return { type: customerConstants.GET_CUSTOMER_SUCCESS, customer };
  }
  function failure(error) {
    return { type: customerConstants.GET_CUSTOMER_FAILURE, error };
  }
}

function getExcelCustomers(filter) {
  return (dispatch) => {
    dispatch(request());

    customerService.getExcelCustomers(filter).then(
      (res) => {
        console.log("got the excel customers");
        dispatch(success(res));
      },
      (error) => {
        dispatch(failure(error.toString()));
        console.log("occure error");
        console.log(error.toString());
        dispatch(alertActions.error(error.toString()));
      }
    );
  };

  function request() {
    console.log("into request");
    return { type: customerConstants.GET_EXCEL_CUSTOMERS_REQUEST };
  }
  function success(data) {
    console.log("into success");
    return { type: customerConstants.GET_EXCEL_CUSTOMERS_SUCCESS, data };
  }
  function failure(error) {
    return { type: customerConstants.GET_EXCEL_CUSTOMERS_FAILURE, error };
  }
}

function addCustomerformalInfo(orderId) {
  return (dispatch) => {
    dispatch(request(customerConstants.ADD_CUSTOMER_INFO_REQUEST));
    customerService.addCustomerformalInfo(orderId).then(
      (res) => {
        if (res === undefined) {
          dispatch(alertActions.error("ارتباط با سرور برقرار نیست"));
          dispatch(
            failure(
              customerConstants.ADD_CUSTOMER_INFO_FAILURE,
              "ارتباط با سرور برقرار نیست"
            )
          );
        } else if (res.success) {
          console.log("order financial confirmed");
          dispatch(
            success(customerConstants.ADD_CUSTOMER_INFO_SUCCESS, res.data)
          );
        } else if (res.success == false) {
          dispatch(
            failure(customerConstants.ADD_CUSTOMER_INFO_FAILURE, res.message)
          );
          dispatch(alertActions.error(res.message));
        }
      },
      (error) => {
        dispatch(
          failure(customerConstants.ADD_CUSTOMER_INFO_FAILURE, error.toString())
        );
        console.log("occure error");
        console.log(error.toString());
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
}

function uploadExcelCustomer(param) {
  return (dispatch) => {
    dispatch(request(customerConstants.UPLOAD_EXCEL_CUSTOMERS_REQUEST));
    customerService.uploadExcelCustomer(param).then(
      (res) => {
        if (res === undefined) {
          dispatch(alertActions.error("ارتباط با سرور برقرار نیست"));
          dispatch(
            failure(
              customerConstants.UPLOAD_EXCEL_CUSTOMERS_FAILURE,
              "ارتباط با سرور برقرار نیست"
            )
          );
        } else if (res.success) {
          console.log("order financial confirmed");
          dispatch(
            success(customerConstants.UPLOAD_EXCEL_CUSTOMERS_SUCCESS, res.data)
          );
        } else if (res.success == false) {
          dispatch(
            failure(
              customerConstants.UPLOAD_EXCEL_CUSTOMERS_FAILURE,
              res.message
            )
          );
          dispatch(alertActions.error(res.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            customerConstants.UPLOAD_EXCEL_CUSTOMERS_FAILURE,
            error.toString()
          )
        );
        console.log("occure error");
        console.log(error.toString());
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
}

function customerToSupplier(param) {
  return (dispatch) => {
    dispatch(request(param));
    customerService.customerToSupplier(param).then(
      (res) => {
        if (res === undefined) {
          dispatch(alertActions.error("ارتباط با سرور برقرار نیست"));
          dispatch(
            failure(
              customerConstants.CREATE_SUPPLIER_BASE_ON_CUSTOMER_FAILURE,
              "ارتباط با سرور برقرار نیست"
            )
          );
        } else if (res.success && res.data.status) {
          dispatch(
            success(
              customerConstants.CREATE_SUPPLIER_BASE_ON_CUSTOMER_SUCCESS,
              res
            )
          );
          dispatch(alertActions.success(res.message));
        } else if (res.success && res.data.status == false) {
          dispatch(
            failure(
              customerConstants.CREATE_SUPPLIER_BASE_ON_CUSTOMER_FAILURE,
              res.message
            )
          );
          dispatch(alertActions.error(res.message));
        }
      },
      (error) => {
        dispatch(
          failure(
            customerConstants.CREATE_SUPPLIER_BASE_ON_CUSTOMER_FAILURE,
            error.toString()
          )
        );
        console.log("occure error");
        console.log(error.toString());
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
  function request(params) {
    return {
      type: customerConstants.CREATE_SUPPLIER_BASE_ON_CUSTOMER_REQUEST,
      params,
    };
  }
}

function addCustomer(param) {
  return (dispatch) => {
    dispatch(request(customerConstants.ADD_CUSTOMER_REQUEST));
    customerService.addCustomer(param).then(
      (res) => {
        if (res === undefined) {
          dispatch(alertActions.error("ارتباط با سرور برقرار نیست"));
          dispatch(
            failure(
              customerConstants.ADD_CUSTOMER_FAILURE,
              "ارتباط با سرور برقرار نیست"
            )
          );
        } else if (res.success && res.data.status) {
          dispatch(success(customerConstants.ADD_CUSTOMER_SUCCESS, res));
          dispatch(alertActions.success(res.message));
        } else if (res.success && res.data.status == false) {
          dispatch(
            failure(customerConstants.ADD_CUSTOMER_FAILURE, res.message)
          );
          dispatch(alertActions.error(res.message));
        }

        setTimeout(() => {
          dispatch(alertActions.clear());
        }, 1000);
      },
      (error) => {
        dispatch(
          failure(customerConstants.ADD_CUSTOMER_FAILURE, error.toString())
        );
        console.log("occure error");
        console.log(error.toString());
        dispatch(alertActions.error(error.toString()));
      }
    );
  };
}

function editCustomer(params, callBack) {
  return dispatch => {
    dispatch(request(customerConstants.EDIT_CUSTOMER_REQUEST));
    customerService.editCustomer(params)
      .then(
        res => {
          if (res === undefined) {
            dispatch(alertActions.error('ارتباط با سرور برقرار نیست'));
            dispatch(failure(customerConstants.EDIT_CUSTOMER_FAILURE, "ارتباط با سرور برقرار نیست"));
          } else if (res.success) {
            dispatch(success(customerConstants.EDIT_CUSTOMER_SUCCESS, res.data));
            return callBack()
          } else if (res.success === false) {
            dispatch(alertActions.error(res.message));
            dispatch(failure(customerConstants.EDIT_CUSTOMER_FAILURE, res.message));
          }

          setTimeout(() => {
            dispatch(alertActions.clear());
          }, 1500);
        },
        error => {
          console.log("-----Error occurred-----");
          console.log(error.toString());
          dispatch(alertActions.error(error.toString()));
          dispatch(failure(customerConstants.EDIT_CUSTOMER_FAILURE, error.toString()));
        }
      );
  };
}

function getRelationCustomer(phoneNumber) {
  return dispatch => {
    dispatch(request(customerConstants.GET_RELATION_CUSTOMER_REQUEST));
    return customerService.getRelationCustomer(phoneNumber)
      .then(
        res => {
          if (res === undefined) {
            dispatch(alertActions.error('ارتباط با سرور برقرار نیست'));
            dispatch(failure(customerConstants.GET_RELATION_CUSTOMER_FAILURE, "ارتباط با سرور برقرار نیست"));
            return 0;
          }
          else if (res.success) {
            dispatch(success(customerConstants.GET_RELATION_CUSTOMER_SUCCESS, res.data));
            return 1;
          }
          else if (res.success == false) {
            dispatch(alertActions.error(res.message));
            dispatch(failure(customerConstants.GET_RELATION_CUSTOMER_FAILURE, res.message));
            return 0;
          }

          setTimeout(() => {
            dispatch(alertActions.clear());
          }, 1500);
        },
        error => {
          dispatch(alertActions.error(error.toString()));
          dispatch(failure(customerConstants.GET_RELATION_CUSTOMER_FAILURE, error.toString()));
          return 0;
        }
      );
  };
}

function addCustomerNote(params, callBack, showAlert = true) {
  return dispatch => {
    dispatch(request(customerConstants.ADD_CUSTOMER_NOTE_REQUEST));
    customerService.addCustomerNote(params)
      .then(
        res => {
          if (res === undefined) {
            dispatch(alertActions.error('ارتباط با سرور برقرار نیست'));
            dispatch(failure(customerConstants.ADD_CUSTOMER_NOTE_FAILURE, "ارتباط با سرور برقرار نیست"));
          } else if (res.success) {
            dispatch(success(customerConstants.ADD_CUSTOMER_NOTE_SUCCESS, res.data));
            if (showAlert) {
              dispatch(alertActions.success(res.message));
              setTimeout(() => dispatch(alertActions.clear()), 1500);
            }

            if (typeof callBack == "function")
              return callBack();
          } else if (res.success === false) {
            dispatch(alertActions.error(res.message));
            dispatch(failure(customerConstants.ADD_CUSTOMER_NOTE_FAILURE, res.message));
          }

          setTimeout(() => dispatch(alertActions.clear()), 1500);
        },
        error => {
          console.log("-----Error occurred-----");
          console.log(error.toString());
          dispatch(alertActions.error(error.toString()));
          dispatch(failure(customerConstants.ADD_CUSTOMER_NOTE_FAILURE, error.toString()));
        }
      );
  };
}

function getCustomerNotes(customerId) {
  return dispatch => {
    dispatch(request(customerConstants.GET_CUSTOMER_NOTES_REQUEST));
    customerService.getCustomerNotes(customerId)
      .then(
        res => {
          if (res === undefined) {
            dispatch(alertActions.error('ارتباط با سرور برقرار نیست'));
            dispatch(failure(customerConstants.GET_CUSTOMER_NOTES_FAILURE, "ارتباط با سرور برقرار نیست"));
          } else if (res.success) {
            dispatch(success(customerConstants.GET_CUSTOMER_NOTES_SUCCESS, res.data));
          } else if (res.success === false) {
            dispatch(alertActions.error(res.message));
            dispatch(failure(customerConstants.GET_CUSTOMER_NOTES_FAILURE, res.message));
          }

          setTimeout(() => {
            dispatch(alertActions.clear());
          }, 1500);
        },
        error => {
          console.log("-----Error occurred-----");
          console.log(error.toString());
          dispatch(alertActions.error(error.toString()));
          dispatch(failure(customerConstants.GET_CUSTOMER_NOTES_FAILURE, error.toString()));
        }
      );
  };
}


function getCustomerRelationToUser(customerId, section, callBack) {
  return dispatch => {
    dispatch(requestWithData(customerConstants.GET_CUSTOMER_RELATION_TO_USER_REQUEST, { section, customerId }));
    customerService.getCustomerRelationToUser(customerId, section)
      .then(
        res => {
          if (res === undefined) {
            dispatch(alertActions.error('ارتباط با سرور برقرار نیست'));
            dispatch(failure(customerConstants.GET_CUSTOMER_RELATION_TO_USER_FAILURE, "ارتباط با سرور برقرار نیست"));
          } else if (res.success) {
            dispatch(success(customerConstants.GET_CUSTOMER_RELATION_TO_USER_SUCCESS, res.data));
            return callBack({ section, permission: res.data })
          } else if (res.success === false) {
            dispatch(alertActions.error(res.message));
            dispatch(failure(customerConstants.GET_CUSTOMER_RELATION_TO_USER_FAILURE, res.message));
          }

          setTimeout(() => {
            dispatch(alertActions.clear());
          }, 1500);
        },
        error => {
          console.log("-----Error occurred-----");
          console.log(error.toString());
          dispatch(alertActions.error(error.toString()));
          dispatch(failure(customerConstants.GET_CUSTOMER_RELATION_TO_USER_FAILURE, error.toString()));
        }
      );
  };
}

function request(type) {
  return { type: type };
}

const requestWithData = (type, data) => ({ type: type, data })

function success(type, data) {
  return { type: type, data };
}

function failure(type, error) {
  return { type: type, error };
}
